import Colors from "../../../theme/colors";

export const style = {
  container: {
    borderRadius: "12px",
    minHeight: "570px",
    background: "#FFFFFF",
  },
  rowStyle: {
    color: "#183053",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  flexC: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: "20px",
  },
  icon: {
    cursor: "pointer",
  },
  tableContainer: {
    backgroundColor: Colors.white,
    overflowX: "scroll",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },
};
